export enum PlaytimeStatus {
  NORMAL = 'NORMAL',
  YELLOW = 'YELLOW',
  ORANGE = 'ORANGE',
  RED = 'RED',
}
